module.exports = __webpack_public_path__ + "img/01.eb38ded8.svg";